import React, { useEffect, useState } from 'react'
import Modal from 'meinian-package/src/baseComponent/modal'
import classNames from 'classnames'
import util from 'meinian-package/src/utils/util'
import { GlobalSettingSubject } from 'meinian-package/src/component/globalSettingModal'
import { UserDefinedPropsContent } from 'component/imageDetail/userDefinedProps'
import noPermissionPrompt from 'meinian-package/src/component/useFunModal/noPermissionPrompt'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import LayerSetting from './layer'
import SampleProcess from './sampleProcess'
import styles from './index.module.less'

const option = [
  { label: '审核者设置', value: 0, show: true, },
  { label: '审核层级设置', value: 1, show: true, },
  { label: '样衣流程设置', value: 2, show: true, },
  { label: '灵感集管理', value: 3, show: true, },
  { label: '自定义样衣属性', value: 4, show: true, },
  { label: '自定义款式属性', value: 5, show: true, },
]

export default ({ visible, onClose, onOk }) => {
  const [value, setValue] = useState(0)

  useEffect(() => {
    if (visible) {
      setValue(0)
    }
  }, [visible])

  return <Modal
    visible={visible}
    onClose={onClose}
    onOk={onOk}
    hiddenCloseIcon={value === 4 || value === 5}
    hiddenFooter
    style={{ minWidth: '640px',
      height: 640,
      borderRadius: '6px',
      width: 'max-content',
      maxWidth: '100%' }}
    footer={false}
    className={styles.managementSettingModal}
  >
    <Subject visible={visible} onClose={onClose} value={value} setValue={setValue} />
  </Modal>
}

const Subject = ({ onClose, value, setValue }) => {
  const { isAuthVersion } = useVersionNumber()

  const ComponentEnum = {
    0: <GlobalSettingSubject className="managementSettingGlobalSettingSubject" hiddenSampleSetting={false} />,
    1: <LayerSetting />,
    2: <SampleProcess />,
    4: <UserDefinedPropsContent className="managementSettingUserDefinedPropsContent" type={2} onClose={onClose} title="自定义样衣属性" />,
    5: <UserDefinedPropsContent className="managementSettingUserDefinedPropsContent" type={1} onClose={onClose} title="自定义款式属性" />
  }

  return <div className={styles.managementSetting}>
    <div className="managementSettingLeftSwitch">
      <div className="managementSettingLeftSwitchTitle">美念管理</div>
      <div className="managementSettingSwitch">
        {
            option.map(item => <div
              onClick={() => {
                if (item.value === 3) {
                  // 监听灵感集领取地址，跳转到美念
                  const token = util.getCookie(process.env.REACT_APP_TOKEN)
                  if (!token || token === 'undefined') {
                    return window.location = `/login#${window.location.pathname + window.location.search}`
                  }
                  window.open(`/team/use-data/inspiration?token=${token}&type=2&paramsType=inspiration&menu=0`)
                  return
                }
                if ((item.value === 1 || item.value === 2 || item.value === 4 || item.value === 5) && isAuthVersion(150001)) {
                  noPermissionPrompt({})
                  return
                }
                setValue(item.value)
              }}
              className={classNames('managementSettingSwitchItem fill-white-bg', { active: item.value === value })}
            >{item.label}</div>)
        }
      </div>
    </div>
    <div className="managementSettingRightContent">
      {ComponentEnum?.[value]}
    </div>
  </div>
}
